"use strict";
/*
 * @Date: 2022-06-22 18:26:54
 * @LastEditTime: 2022-07-02 10:32:18
 * @FilePath: /activity_cfhd_a20220702mact/index.ts
 * @Description:
 */
/*
 * @LastEditors: Please set LastEditors
 * @Date: 2022-01-10 15:07:56
 * @LastEditTime: 2022-06-24 12:13:40
 * @Descripttion:
 */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
// declare function jQuery( cb: Function ): any;
var utils_1 = require("./utils");
var doAmsActionDonson = function (activityId, flowId, resolve, reject, params, pop, before, config) {
    console.error('引入功能：', '记得选择模块呀！');
};
window.doAmsSubmit = utils_1.doAmsSubmit;
window.cfhdCallbackObj = { sOutValue1: '', sOutValue2: '', sOutValue3: '', sOutValue4: '', sOutValue5: '', sOutValue6: '', sOutValue7: '', sOutValue8: '' };
var iActivityId = 479482; // 活动id
var giftId = 490479; // 礼包id
var mainfunc = function () {
    // 原有的OutPutDonson函数
    // 初始进入访问AMS 后续不再访问
    function OutPutDonson(handleType, initFunc) {
        if (!initFunc) {
            console.error('引入功能：', '必须写初始化函数');
        }
        if (handleType === 'init') {
            // console.log(iActivityId)
            doAmsActionDonson(iActivityId, initFlow, initFunc, '', '', false, function () {
                return true;
            }, '');
        }
        else {
            initFunc(window.cfhdCallbackObj);
        }
    }
    var initFunction = requireInitFunc1;
    var initFlow = 866714;
    // var initFlow = 0 // 活动初始化流程
    //  页面初始化, 默认是最大次数1, 支持 maxCount
    // "{class: '.btn_left', flowId: 828331, key: 'sOutValue3', postion: '0', resolve: ,maxCount: 1, notNeedGray: false}"
    // maxCount: 资格数量 执行置灰  默认是 1
    // grayClass
    // params
    // before  在config生成之后，ams提交之前
    // resolve : function(callback){alert('donson'+callback.sMsg)}}
    // reject : function(callback){alert('donson'+callback.sMsg)}}
    // notNeedSubmit
    // config ： 会覆盖原有的全局的iActivityId  giftid
    var btnClassList1 = [
        // tab1 节点活跃
        { class: '.tab1_yuyue', flowId: 865834, key: 'sOutValue1', postion: '1' },
        { class: '.tab1_get_yuyue_gift', flowId: 865835, key: 'sOutValue1', postion: '2' },
        { class: '.tab1_get_gift_reback', flowId: 865836, key: 'sOutValue1', postion: '3' },
        { class: '.tab1_jiedian_hy_1', flowId: 865838, key: 'sOutValue1', postion: '4', params: { gift_type1: 1 } },
        { class: '.tab1_jiedian_hy_2', flowId: 865838, key: 'sOutValue1', postion: '5', params: { gift_type1: 2 } },
        { class: '.tab1_jiedian_hy_3', flowId: 865838, key: 'sOutValue1', postion: '6', params: { gift_type1: 3 } },
        { class: '.tab1_jiedian_hy_4', flowId: 865838, key: 'sOutValue1', postion: '7', params: { gift_type1: 4 } },
        { class: '.tab1_jiedian_hy_5', flowId: 865838, key: 'sOutValue1', postion: '8', params: { gift_type1: 5 } },
        { class: '.tab1_jiedian_hy_6', flowId: 865838, key: 'sOutValue1', postion: '9', params: { gift_type1: 6 } },
        { class: '.tab1_share_gift', flowId: 865867, key: 'sOutValue1', postion: '10', params: { shareCode1: '' }, before: getTab1ShareCode },
        { class: '.tab1_share_gift_hui1xin2', flowId: 865876, key: 'sOutValue1', postion: '11' },
        { class: '.tab1_share_gift_success', flowId: 865874, key: 'sOutValue1', postion: '12' },
        { class: '.tab1_share_gift_new_old', flowId: 865881, key: 'sOutValue1', postion: '13', maxCount: 4 },
        { class: '.tab1_yuyue_znq', flowId: 865292, key: 'sOutValue1', postion: '16', config: { iActivityId: 474696, giftId: 486639 } }
    ];
    var btnClassList2 = [
        // tab1 节点活跃
        { class: '.tab2_create_team', flowId: 866030, needInitSubmit: true },
        { class: '.tab2_join_team', flowId: 866032, params: { teamid: '' }, before: getTab2TeamId, needInitSubmit: true },
        // 推荐团
        { class: '.tab2_tuijian_team', flowId: 866038, needInitSubmit: true },
        // 提升等级
        { class: '.tab2_up_team_level', flowId: 866040, needInitSubmit: true },
        // 换一批
        { class: '.tab2_refresh_team_list', flowId: 866035, resolve: function () { }, needInitSubmit: true },
        { class: '.tab2_have_team', flowId: 866043, key: 'sOutValue2', postion: '0' },
        { class: '.tab2_team_count_2', flowId: 866045, key: 'sOutValue2', postion: '1', params: { team_count: 3 } },
        { class: '.tab2_team_count_3', flowId: 866045, key: 'sOutValue2', postion: '2', params: { team_count: 4 } },
        { class: '.tab2_team_count_5', flowId: 866045, key: 'sOutValue2', postion: '3', params: { team_count: 5 } },
        { class: '.tab2_team_level_1', flowId: 866047, key: 'sOutValue2', postion: '4', params: { level_count: 1 } },
        { class: '.tab2_team_level_3', flowId: 866047, key: 'sOutValue2', postion: '5', params: { level_count: 3 } },
        { class: '.tab2_team_level_5', flowId: 866047, key: 'sOutValue2', postion: '6', params: { level_count: 5 } },
        { class: '.tab2_team_level_7', flowId: 866047, key: 'sOutValue2', postion: '7', params: { level_count: 7 } },
        // level 10,need pick one from two
        { class: '.tab2_team_level_10_1', flowId: 866082, key: 'sOutValue2', postion: '8', params: { gift_type: 1 } },
        { class: '.tab2_team_level_10_2', flowId: 866082, key: 'sOutValue2', postion: '9', params: { gift_type: 2 } },
        { class: '.tab2_jbp_one_game', flowId: 866150, key: 'sOutValue2', postion: '10', needInitSubmit: true },
        { class: '.tab2_jbp_zh', flowId: 866162, key: 'sOutValue2', postion: '11', needInitSubmit: true, maxCount: 2 },
        { class: '.tab2_jbp_live_plat', flowId: 866169, key: 'sOutValue2', postion: '12', needInitSubmit: true, maxCount: 2 },
        { class: '.tab2_jbp_yuyue', flowId: 866172, key: 'sOutValue2', postion: '13', needInitSubmit: true },
        { class: '.tab2_jbp_level_1', flowId: 866126, key: 'sOutValue2', postion: '14', params: { gift_type3: 1 } },
        { class: '.tab2_jbp_level_2', flowId: 866126, key: 'sOutValue2', postion: '15', params: { gift_type3: 2 } },
        { class: '.tab2_jbp_level_3', flowId: 866126, key: 'sOutValue2', postion: '16', params: { gift_type3: 3 } },
        { class: '.tab2_jbp_level_4', flowId: 866126, key: 'sOutValue2', postion: '17', params: { gift_type3: 4 } },
        { class: '.tab2_jbp_level_5', flowId: 866126, key: 'sOutValue2', postion: '18', params: { gift_type3: 5 } },
        { class: '.tab2_jbp_level_7', flowId: 866126, key: 'sOutValue2', postion: '19', params: { gift_type3: 7 } },
        { class: '.tab2_jbp_level_9', flowId: 866126, key: 'sOutValue2', postion: '20', params: { gift_type3: 9 } },
        { class: '.tab2_jbp_level_10', flowId: 866126, key: 'sOutValue2', postion: '21', params: { gift_type3: 10 } },
        { class: '.tab2_jbp_level_12', flowId: 866126, key: 'sOutValue2', postion: '22', params: { gift_type3: 12 } },
        { class: '.tab2_jbp_level_13_1', flowId: 866141, key: 'sOutValue2', postion: '23', params: { gift_type4: 1 } },
        { class: '.tab2_jbp_level_13_2', flowId: 866141, key: 'sOutValue2', postion: '24', params: { gift_type4: 2 } },
        { class: '.tab2_jbp_level_13_3', flowId: 866141, key: 'sOutValue2', postion: '25', params: { gift_type4: 3 } },
        { class: '.tab2_jbp_level_13_4', flowId: 866141, key: 'sOutValue2', postion: '26', params: { gift_type4: 4 } },
        { class: '.tab2_jbp_level_13_5', flowId: 866141, key: 'sOutValue2', postion: '27', params: { gift_type4: 5 } },
        { class: '.tab2_jbp_level_13_6', flowId: 866141, key: 'sOutValue2', postion: '28', params: { gift_type4: 6 } },
        { class: '.tab2_jbp_team_level_1', flowId: 866111, key: 'sOutValue2', postion: '29', params: { gift_type: 1 } },
        { class: '.tab2_jbp_team_level_3', flowId: 866111, key: 'sOutValue2', postion: '30', params: { gift_type: 3 } },
        { class: '.tab2_jbp_team_level_6', flowId: 866111, key: 'sOutValue2', postion: '31', params: { gift_type: 6 } },
        { class: '.tab2_jbp_team_level_8_1', flowId: 866123, key: 'sOutValue2', postion: '32', params: { gift_type2: 1 } },
        { class: '.tab2_jbp_team_level_8_2', flowId: 866123, key: 'sOutValue2', postion: '33', params: { gift_type2: 2 } }
    ];
    var btnClassList3 = [
        { class: '.tab3_newold_jbp_level_1', flowId: 866542, key: 'sOutValue3', postion: '0' },
        { class: '.tab3_newold_jbp_level_3_1', flowId: 867541, key: 'sOutValue3', postion: '1', params: { gift_type1: 1 } },
        { class: '.tab3_newold_jbp_level_3_2', flowId: 867541, key: 'sOutValue3', postion: '2', params: { gift_type1: 2 } },
        { class: '.tab3_newold_jbp_level_3_3', flowId: 867541, key: 'sOutValue3', postion: '3', params: { gift_type1: 3 } },
        { class: '.tab3_newold_jbp_level_5_1', flowId: 867556, key: 'sOutValue3', postion: '4', params: { gift_type2: 1 } },
        { class: '.tab3_newold_jbp_level_5_2', flowId: 867556, key: 'sOutValue3', postion: '5', params: { gift_type2: 2 } },
        { class: '.tab3_newold_jbp_level_10_1', flowId: 867557, key: 'sOutValue3', postion: '6', params: { gift_type3: 1 } },
        { class: '.tab3_newold_jbp_level_10_2', flowId: 867557, key: 'sOutValue3', postion: '7', params: { gift_type3: 2 } },
        { class: '.tab3_newold_level_2', flowId: 867596, key: 'sOutValue3', postion: '8', params: { level_count: 2 } },
        { class: '.tab3_newold_level_4', flowId: 867596, key: 'sOutValue3', postion: '9', params: { level_count: 4 } },
        { class: '.tab3_newold_level_6', flowId: 867596, key: 'sOutValue3', postion: '10', params: { level_count: 6 } },
        { class: '.tab3_newold_level_8_1', flowId: 867604, key: 'sOutValue3', postion: '11', params: { gift_type4: 1 } },
        { class: '.tab3_newold_level_8_2', flowId: 867604, key: 'sOutValue3', postion: '12', params: { gift_type4: 2 } },
        // 14是渠道
        { class: '.tab3_qudao_1', flowId: 868693, key: 'sOutValue3', postion: '14', params: { gift_type3: 1 } },
        { class: '.tab3_qudao_2', flowId: 868693, key: 'sOutValue3', postion: '15', params: { gift_type3: 2 } },
        { class: '.tab3_qudao_3', flowId: 868693, key: 'sOutValue3', postion: '16', params: { gift_type3: 3 } }
    ];
    var btnClassList4 = [
        {
            class: '.tab4_create_team',
            flowId: 866652,
            notNeedSubmit: true,
            before: function () {
                ;
                window.amsCfg_866652.sData.area = window.areaid;
                return true;
            }
        },
        { class: '.tab4_join_team', flowId: 866661, params: { teamid: '', area: '' }, notNeedSubmit: true, before: getTab4TeamId },
        // 推荐团
        { class: '.tab4_tuijian_team', flowId: 866665 },
        // 提升等 级
        // cf 一个
        {
            class: '.tab4_up_team_level',
            flowId: 866666,
            notNeedSubmit: true,
            before: function () {
                ;
                window.amsCfg_866666.sData.area = window.areaid;
                return true;
            }
        },
        // 换一批
        { class: '.tab4_refresh_team_list', flowId: 866664, resolve: function () { } },
        { class: '.tab4_have_team', flowId: 866672, key: 'sOutValue4', postion: '0' },
        { class: '.tab4_team_count_2', flowId: 866673, key: 'sOutValue4', postion: '1', params: { team_count: 2 } },
        { class: '.tab4_team_count_3', flowId: 866673, key: 'sOutValue4', postion: '2', params: { team_count: 3 } },
        { class: '.tab4_team_count_5', flowId: 866673, key: 'sOutValue4', postion: '3', params: { team_count: 5 } },
        { class: '.tab4_team_level_1', flowId: 866674, key: 'sOutValue4', postion: '4', params: { level_count: 1 } },
        { class: '.tab4_team_level_3', flowId: 866674, key: 'sOutValue4', postion: '5', params: { level_count: 3 } },
        { class: '.tab4_team_level_5', flowId: 866674, key: 'sOutValue4', postion: '6', params: { level_count: 5 } },
        { class: '.tab4_team_level_7', flowId: 866674, key: 'sOutValue4', postion: '7', params: { level_count: 7 } },
        { class: '.tab4_team_level_10', flowId: 866674, key: 'sOutValue4', postion: '8', params: { level_count: 10 } },
        // 四选1
        {
            class: '.tab4_4pick1_1',
            flowId: 866574,
            key: 'sOutValue4',
            postion: '9',
            params: { gift_type: 1 },
            notNeedSubmit: true,
            before: function () {
                ;
                window.amsCfg_866574.sData.area = window.areaid;
                return true;
            }
        },
        {
            class: '.tab4_4pick1_2',
            flowId: 866574,
            key: 'sOutValue4',
            postion: '10',
            params: { gift_type: 2 },
            notNeedSubmit: true,
            before: function () {
                ;
                window.amsCfg_866574.sData.area = window.areaid;
                return true;
            }
        },
        {
            class: '.tab4_4pick1_3',
            flowId: 866574,
            key: 'sOutValue4',
            postion: '11',
            params: { gift_type: 3 },
            notNeedSubmit: true,
            before: function () {
                ;
                window.amsCfg_866574.sData.area = window.areaid;
                return true;
            }
        },
        {
            class: '.tab4_4pick1_4',
            flowId: 866574,
            key: 'sOutValue4',
            postion: '12',
            params: { gift_type: 4 },
            notNeedSubmit: true,
            before: function () {
                ;
                window.amsCfg_866574.sData.area = window.areaid;
                return true;
            }
        },
        // 2_1
        {
            class: '.tab4_2pick1_1',
            flowId: 866651,
            key: 'sOutValue4',
            postion: '13',
            params: { gift_type2: 1 },
            notNeedSubmit: true,
            before: function () {
                ;
                window.amsCfg_866651.sData.area = window.areaid;
                return true;
            }
        },
        {
            class: '.tab4_2pick1_2',
            flowId: 866651,
            key: 'sOutValue4',
            postion: '14',
            params: { gift_type2: 2 },
            notNeedSubmit: true,
            before: function () {
                ;
                window.amsCfg_866651.sData.area = window.areaid;
                return true;
            }
        }
    ];
    var allBtn = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], btnClassList1, true), btnClassList2, true), btnClassList3, true), btnClassList4, true);
    // 初始化函数必写
    // callbackObj  输入页面的动作返回
    // tab1 初始化
    var onceCtrl = false;
    var onceCtrl2 = false;
    var onceCtrl3 = false;
    var onceCtrl4 = false;
    var onceCtrl5 = false;
    function requireInitFunc1(callbackObj) {
        console.log(callbackObj);
        // support2Ams()
        if (!onceCtrl4) {
            $('.share-mask').click(function () {
                closeDialog();
            });
            onceCtrl4 = true;
        }
        // (window as any).cfhdCallbackObj = Object.assign((window as any).cfhdCallbackObj, callbackObj)
        ;
        window.cfhdCallbackObj.sOutValue1 = callbackObj.sOutValue1;
        window.cfhdCallbackObj.sOutValue2 = callbackObj.sOutValue2;
        window.cfhdCallbackObj.sOutValue3 = callbackObj.sOutValue3;
        window.cfhdCallbackObj.sOutValue4 = callbackObj.sOutValue4;
        window.cfhdCallbackObj.sOutValue6 = callbackObj.sOutValue6;
        (0, utils_1.btnGrayNormalHandle)(callbackObj, allBtn, 'gray dis gare'); // 需要置灰时 需要引入
        var sput1 = callbackObj.sOutValue1.split(',');
        var sput2 = callbackObj.sOutValue2.split(',');
        var sput3 = callbackObj.sOutValue3.split(',');
        var sput4 = callbackObj.sOutValue4.split(',');
        var sput6 = callbackObj.sOutValue6.split(',');
        // // 4 5是限量
        // if (parseInt(sput1[4]) > 0) $('.firstLimit').text('是')
        // else $('.firstLimit').text('否')
        // if (parseInt(sput1[5]) > 0) $('.secondLimit').text('是')
        // else $('.secondLimit').text('否')
        // // 10 11 12 三个    // 4 5是限量
        // if (parseInt(sput1[10]) > 0) $('.tab1_limit_10').text('是')
        // else $('.tab1_limit_10').text('否')
        // if (parseInt(sput1[11]) > 0) $('.tab1_limit_11').text('是')
        // else $('.tab1_limit_11').text('否')
        // if (parseInt(sput1[12]) > 0) $('.tab1_limit_12').text('是')
        // else $('.tab1_limit_12').text('否')
        // if (sput6.length > 2) {
        //   itemList = sput6
        //   showXuyuanState(sput6)
        // }
        // var sput4 = callbackObj.sOutValue4.split(',')
        // // 8是天数
        // $('.tab4_login_day').text(sput4[8])
        // // 14new  15 old
        $('.tab1_new_people').text(sput1[14]);
        $('.tab1_old_people').text(sput1[15]);
        $('.tab1_week_count').text(sput1[17]);
        if (parseInt(sput1[16]) > 0 && parseInt(sput2[13]) === 0) {
            $('.tab2_jbp_one_game').attr('href', "javascript:func_479482_866172_13()");
        }
        var shareCode = sput1[0];
        var tab1PcUrl = 'https://cfhd.cf.qq.com/cp/a20220702mact/index.html?shareCode1=' + shareCode;
        var tab1H5Url = 'https://cfhd.cf.qq.com/cp/a20220702mact/m.html?shareCode1=' + shareCode;
        $('#copytext2_tab1').val(tab1PcUrl);
        if (!onceCtrl) {
            onceCtrl = true;
            var shareObj1 = (0, utils_1.initShareFunc)(tab1PcUrl, tab1H5Url, '7.2起预约全新版本', 'WeGame专属皮肤免费拿', 'WeGame专属皮肤免费拿', 'https://game.gtimg.cn/images/cfhd/cp/a20220702mact/share1.jpg', { height: 220, width: 220, class: '.qrcode1' }, 'share');
            $('.tab1_btn_share_pc').click(shareObj1.shareQQ);
            $('.tab1_btn_share_h5').click(shareObj1.shareH5);
            $('.tab1_btn_share_zone').click(shareObj1.shareZone);
            $('.tab1_btn_share_copy').click(function () {
                (0, utils_1.copyText)(tab1PcUrl, function () {
                    alert('复制成功！');
                });
            });
        }
        $('.tab2_jbp_level').text(sput6[0]);
        $('.tab3_jbp_level').text(sput6[0]);
        $('.tab2_jbp_team_people_level').text(sput2[34]);
        $('.tab2_jbp_team_level').text(sput6[1]);
        //     // 17队伍id，18是否队长，19个人等级，20团队等级，21人数, 22 是否已经推荐过了
        //     // 2队伍id，3是否队长，4个人等级，5团队等级，6人数, 7 是否已经推荐过了
        if (sput6[2] != '0') {
            // 有队伍
            $('.tab2_team').show();
            $('.tab2_no_team').hide();
            $('#tab2_team_id_have').val(sput6[2]);
            $('.tab2_copy_team_id').unbind('click');
            $('.tab2_copy_team_id').click(function () {
                (0, utils_1.copyText)(sput6[2], function () {
                    alert('复制成功！');
                });
            });
            if (parseInt(sput6[3]) !== 1 || parseInt(sput6[7]) == 1) {
                // console.log(44444)
                // bu是队长, 或者 点过
                $('.tab2_tuijian_team').hide();
            }
        }
        else {
            // 没队伍
            $('.tab2_no_team').show();
            $('.tab2_team').hide();
        }
        // 8开始队伍猎豹
        var teamList = sput6.slice(8);
        console.log(teamList);
        // var domstr = '<tr><th>团队ID</th><th>团队人数</th></tr>'
        var domstr = '';
        if (teamList[0] != '0' && teamList[0] != '') {
            teamList.forEach(function (ele) {
                var team = ele.split('|');
                // <tr> <td>1111111</td> <td>1111111</td> </tr>
                domstr += "<tr> <td>".concat(team[0], "</td> <td>").concat(team[1], "</td> </tr>");
                // domstr += '<tr><th>' + team[0] + '</th><th>' + team[1] + '</th></tr>'
            });
        }
        $('.tab2_team_list').empty();
        $('.tab2_team_list').append(domstr);
        $('.tab2_people_level').text(sput6[4]);
        $('.tab2_team_level').text(sput6[5]);
        $('.tab3_people_level').text(sput6[4]);
        $('.tab3_team_level').text(sput6[5]);
        $('.tab2_team_count').text(sput6[6]);
        //     // 2队伍id，3是否队长，4个人等级，5团队等级，6人数, 7 是否已经推荐过了
        //  // 9队伍id，10是否队长，11个人等级，12团队等级，13人数, 14 是否已经推荐过了
        //  // 15队伍id，16是否队长，17个人等级，18团队等级，19人数, 20 是否已经推荐过了
        if (sput4[15] != '0') {
            // 有队伍
            $('.tab4_team').show();
            $('.tab4_no_team').hide();
            $('#tab4_team_id_have').val(sput4[15]);
            $('.tab4_copy_team_id').unbind('click');
            $('.tab4_copy_team_id').click(function () {
                (0, utils_1.copyText)(sput4[15], function () {
                    alert('复制成功！');
                });
            });
            if (parseInt(sput4[16]) !== 1 || parseInt(sput4[20]) == 1) {
                // console.log(44444)
                // bu是队长, 或者 点过
                $('.tab4_tuijian_team').hide();
            }
        }
        else {
            // 没队伍
            $('.tab4_no_team').show();
            $('.tab4_team').hide();
        }
        // 8开始队伍猎豹
        var tab4teamList = sput4.slice(21);
        // console.log  (tab4teamList)
        // var domstr = '<tr><th>团队ID</th><th>团队人数</th></tr>'
        var domstr = '';
        if (tab4teamList[0] != '0' && tab4teamList[0] != '') {
            tab4teamList.forEach(function (ele) {
                var team = ele.split('|');
                // <tr> <td>1111111</td> <td>1111111</td> </tr>
                domstr += "<tr> <td>".concat(team[0], "</td> <td>").concat(team[1], "</td> </tr>");
                // domstr += '<tr><th>' + team[0] + '</th><th>' + team[1] + '</th></tr>'
            });
        }
        $('.tab4_team_list').empty();
        $('.tab4_team_list').append(domstr);
        $('.tab4_people_level').text(sput4[17]);
        $('.tab4_team_level').text(sput4[18]);
        $('.tab4_team_count').text(sput4[19]);
        if (parseInt(sput3[13]) > 0) {
            $('.buy_2_yuan').addClass('gray');
        }
        if (parseInt(sput3[17]) < 3) {
            $('.tab3_new_old').show();
        }
    }
    // TODO动态加入预约领取
    doAmsActionDonson = function (a, b, resolve, reject, params, pop, before, config) {
        console.log('flowid', b);
        // 全局拿一个礼包单id
        (0, utils_1.giftConfig)(a, giftId, b, OutPutDonson, initFunction, resolve, reject, params, pop, config);
        var beforeRes = before();
        if (beforeRes)
            doAmsAction(a, b);
        else
            console.log('exec error');
    };
    (0, utils_1.handleNormalBtnClassAndAmsSbumit)(allBtn, iActivityId, doAmsActionDonson, initFunction, initFlow);
    // allBtn.forEach((ele) => {
    //   $(ele.class).unbind('click')
    //   $(ele.class).click(function () {
    //     alert('敬请期待！')
    //   })
    // })
    function doInitFunction() {
        setTimeout(function () {
            OutPutDonson('init', initFunction);
        }, 100);
    }
    return doInitFunction;
};
// var mainfunc2 = function () {
//   var doAmsActionDonson = function (activityId: number, flowId: number, resolve: Function, reject: any, params: any, pop: boolean, before: Function, config: any) {
//     console.error('引入功能：', '记得选择模块呀！')
//   };
//   //  amsCfg自动生成
//   function giftConfig(iActivityId, flowId, resolve, reject, params, pop, config) {
//     var sData = {}
//     // var initFunc
//     var resolveFunc
//     var rejectFunc
//     var popMask
//     if (pop == undefined) {
//       popMask = true
//     } else {
//       popMask = pop
//     }
//     if (config == undefined) {
//       config = {}
//     }
//     if (params == undefined) {
//       params = {}
//     } else if (params && typeof params == 'object' && Object.keys(params).length > 0) {
//       Object.keys(params).forEach(function (ele) {
//         sData[ele] = params[ele]
//       })
//       // sData = JSON.parse(JSON.stringify(params));
//     }
//     if (resolve != undefined && resolve !== '') resolveFunc = resolve
//     else resolveFunc = function (callbackObj) {
//       alert(callbackObj.sMsg);
//       OutPutDonson('init', initFunction)
//     }
//     if (reject != undefined && reject !== '') rejectFunc = reject
//     else rejectFunc = function (callbackObj) {
//       support2Ams()
//       if (callbackObj.iRet == '202') {
//         TGDialogS('bind')
//       } else if (callbackObj.sMsg === '抱歉，您还没有角色，无法参与~' || callbackObj.sMsg === '抱歉，您还未拥有角色，无法参与~') {
//         // 拉起来预创角
//         TGDialogS('name-gift')
//       } else if (callbackObj.sMsg == '当前大区角色不存在，请重新选择~') {
//         alert(callbackObj.sMsg);
//       } else {
//         alert(callbackObj.sMsg);
//       }
//     }
//     var flowCfg = 'amsCfg_' + flowId
//     console.log(flowCfg)
//     window[flowCfg] = {
//       'iAMSActivityId': config.iActivityId || iActivityId, // AMS活动号
//       'activityId': config.giftId || giftId, // 模块实例号
//       'sData': sData,
//       '_everyRead': true,
//       'sNeedSubmitPopDiv': popMask,
//       //可选扩展参数sData，
//       /**
//       "sData":{
//           "sPlatId":1,
//           "sArea":4,
//           "appid":"100584625",
//           "sServiceType":"pao"
//           },
//       **/
//       'onBeginGetGiftEvent': function () {
//         return 0; // 抽奖前事件，返回0表示成功
//       },
//       'onGetGiftFailureEvent': function (callbackObj) { // 抽奖失败事件
//         rejectFunc(callbackObj)
//         return;
//       },
//       'onGetGiftSuccessEvent': function (callbackObj) { // 抽奖成功事件
//         resolveFunc(callbackObj)
//         return;
//       }
//     };
//   }
//   // 原有的OutPutDonson函数
//   // 初始进入访问AMS 后续不再访问
//   function OutPutDonson(handleType, initFunc) {
//     if (!initFunc) {
//       console.error('引入功能：', '必须写初始化函数')
//     }
//     if (handleType === 'init') {
//       console.log(iActivityId)
//       doAmsActionDonson(iActivityId, initFlow, initFunc, '', '', false, function () {
//         return true
//       }, '')
//     } else {
//       initFunc((window as any).cfhdCallbackObj)
//     }
//   }
//   //  页面 AMS 强相关功能
//   var initFunction = requireInitFunc1
//   var iActivityId = 474696; // 活动id
//   var giftId = 486639; // 礼包id
//   var initFlow = 864168
//   const btnClassList5: Array<amsBtn> = [
//     { class: '.tab5_create_team', flowId: 863221, needInitSubmit: true },
//     { class: '.tab5_join_team', flowId: 863222, params: { teamid: '' }, before: getTab5TeamId, needInitSubmit: true },
//     // 推荐团
//     { class: '.tab5_tuijian_team', flowId: 863225, needInitSubmit: true },
//     // 提升等级
//     { class: '.tab5_up_team_level', flowId: 863235, needInitSubmit: true },
//     // 换一批
//     { class: '.tab5_refresh_team_list', flowId: 863224, resolve: function () { }, needInitSubmit: true },
//     { class: '.tab5_have_team', flowId: 863239, key: 'sOutValue5', postion: '1' },
//     { class: '.tab5_team_count_2', flowId: 863240, key: 'sOutValue5', postion: '2', params: { team_count: 2 } },
//     { class: '.tab5_team_count_3', flowId: 863240, key: 'sOutValue5', postion: '3', params: { team_count: 3 } },
//     { class: '.tab5_team_count_5', flowId: 863240, key: 'sOutValue5', postion: '4', params: { team_count: 5 } },
//     { class: '.tab5_team_level_1', flowId: 863308, key: 'sOutValue5', postion: '5', params: { level_count: 1 } },
//     { class: '.tab5_team_level_3', flowId: 863308, key: 'sOutValue5', postion: '6', params: { level_count: 3 } },
//     { class: '.tab5_team_level_5', flowId: 863308, key: 'sOutValue5', postion: '7', params: { level_count: 5 } },
//     { class: '.tab5_team_level_7', flowId: 863308, key: 'sOutValue5', postion: '8', params: { level_count: 7 } },
//     // level 10,need pick one from two
//     { class: '.tab5_team_level_10_1', flowId: 863312, key: 'sOutValue5', postion: '9', params: { gift_type: 1 } },
//     { class: '.tab5_team_level_10_2', flowId: 863312, key: 'sOutValue5', postion: '10', params: { gift_type: 2 } },
//     { class: '.tab5_share_gift', flowId: 864112, key: 'sOutValue5', postion: '11', params: { shareCode5: '' }, before: getTab5ShareCode },
//     // 新老兵抽奖
//     { class: '.tab5_new_old_gift', flowId: 864114, key: 'sOutValue5', postion: '12', maxCount: 3 },
//     { class: '.tab5_share_success', flowId: 864113, key: 'sOutValue5', postion: '13' },
//     // 分享抽奖
//     { class: '.tab5_share_1_2', flowId: 864115, key: 'sOutValue5', postion: '14' },
//     // 不放回三次
//     // { class: '.tab5_3_choujiang', flowId: 859638, key: 'sOutValue5', postion: '15', maxCount: 3 },
//   ]
//   const btnClassList6: Array<amsBtn> = [
//     { class: '.tab6_newold_one_game', flowId: 864411, key: 'sOutValue7', postion: '1'},
//     { class: '.tab6_newold_one_game2_1_2', flowId: 864432, key: 'sOutValue7', postion: '2', params: { gift_type: 1 }},
//     { class: '.tab6_newold_one_game2_1_1', flowId: 864432, key: 'sOutValue7', postion: '3', params: { gift_type: 2 }},
//     { class: '.tab6_newold_login_day_1', flowId: 864440, key: 'sOutValue7', postion: '4', params: { gift_type2: 1 }},
//     { class: '.tab6_newold_login_day_2', flowId: 864440, key: 'sOutValue7', postion: '5', params: { gift_type2: 2 }},
//     { class: '.tab6_newold_login_day_3', flowId: 864440, key: 'sOutValue7', postion: '6', params: { gift_type2: 3 }},
//     { class: '.tab6_newold_login_day_4_1', flowId: 864442, key: 'sOutValue7', postion: '7', params: { gift_type3: 1 }},
//     { class: '.tab6_newold_login_day_4_2', flowId: 864442, key: 'sOutValue7', postion: '8', params: { gift_type3: 2 }},
//     { class: '.tab6_shenghua_login_day_1', flowId: 864462, key: 'sOutValue7', postion: '9', params: { gift_type4: 1 }, needInitSubmit: true},
//     { class: '.tab6_shenghua_login_day_2', flowId: 864462, key: 'sOutValue7', postion: '10', params: { gift_type4: 2 }, needInitSubmit: true},
//     { class: '.tab6_shenghua_login_day_3', flowId: 864462, key: 'sOutValue7', postion: '11', params: { gift_type4: 3 }, needInitSubmit: true},
//     { class: '.tab6_shenghua_login_day_5', flowId: 864462, key: 'sOutValue7', postion: '12', params: { gift_type4: 5 }, needInitSubmit: true},
//     { class: '.tab6_shenghua_login_day_6', flowId: 864462, key: 'sOutValue7', postion: '13', params: { gift_type4: 6 }, needInitSubmit: true},
//     { class: '.tab6_every_day_1', flowId: 864449, key: 'sOutValue7', postion: '14', maxCount: 10, needInitSubmit: true},
//     { class: '.tab6_every_day_3', flowId: 864453, key: 'sOutValue7', postion: '15', maxCount: 10, needInitSubmit: true},
//     { class: '.tab6_share_relate', flowId: 864366, key: 'sOutValue7', postion: '16', params: {shareCode6: ''}, before: getTab6ShareCode},
//     { class: '.tab6_share_relate_success', flowId: 864642, key: 'sOutValue7', postion: '17' },
//     { class: '.tab6_share_relate_old_1', flowId: 865015, key: 'sOutValue7', postion: '18', params: { gift_type: 1 }, needInitSubmit: true},
//     { class: '.tab6_share_relate_old_2', flowId: 865015, key: 'sOutValue7', postion: '19', params: { gift_type: 2 }, needInitSubmit: true},
//     { class: '.tab6_share_relate_old_3', flowId: 865015, key: 'sOutValue7', postion: '20', params: { gift_type: 3 }, needInitSubmit: true},
//     { class: '.tab6_share_relate_old_4', flowId: 865015, key: 'sOutValue7', postion: '21', params: { gift_type: 4 }, needInitSubmit: true},
//     { class: '.tab6_share_relate_old_5', flowId: 865015, key: 'sOutValue7', postion: '22', params: { gift_type: 5 }, needInitSubmit: true},
//   ]
//   for( let i = 1; i < 14; i ++ ) {
//     btnClassList6.push({ class: '.tab6_shenghua_duihuan_'+i, flowId: 865038, key: 'sOutValue7', postion: 22+i+'', needInitSubmit: true, params: { gift_type2: i }},)
//   }
//   var allBtn = [...btnClassList5, ...btnClassList6]
//   // var allBtn = [...btnClassList5]
//   var onceCtrl = false
//   var onceCtrl2 = false
//   var onceCtrl3 = false
//   var onceCtrl4 = false
//   var onceCtrl5 = false
//   function requireInitFunc1(callbackObj) {
//     if (!onceCtrl2) {
//       // support2Ams()
//       onceCtrl2 = true
//     }
//     console.log(callbackObj);
//     (window as any).cfhdCallbackObj.sOutValue5 = callbackObj.sOutValue5;
//     (window as any).cfhdCallbackObj.sOutValue7 = callbackObj.sOutValue7;
//     (window as any).cfhdCallbackObj.sOutValue8 = callbackObj.sOutValue8;
//     btnGrayNormalHandle(callbackObj, allBtn, 'gray  dis') // 需要置灰时 需要引入
//     const sOutput8 = callbackObj.sOutValue8.split(',');
//     $('.shenghua_coin_num').text(sOutput8[0])
//     $('.tab6_newandold_shenghua_new').text(parseInt(sOutput8[1]))
//     $('.tab6_newandold_shenghua_old').text(parseInt(sOutput8[2]))
//     $('.tab6_new_old_day_count').text(sOutput8[3])
//     $('.tab6_shenghuaday_count').text(sOutput8[4])
//     if (sOutput8[5].length>4) {
//       try {
//         // <div class="my-rank"><span>1</span><span>昵称昵称昵称</span><span>11</span><span>11</span></div>
//         const userInfo = decodeURIComponent(sOutput8[5]).split('|')
//         console.log(userInfo)
//         // $('.tab4_user_name').text(`昵称：${userInfo[0]}`)
//         $('.my-rank').empty()
//         $('.nickname_tab5').text(userInfo[0])
//         // nick,rank,total,win
//         $('.my-rank').append(`<span>${userInfo[1]}</span><span>${userInfo[0]}</span><span>${userInfo[3]}</span><span>${userInfo[2]}</span>`)
//       } catch (error) {
//         console.log(error)
//         console.log('初始化出错')
//       }
//     }
//     const sOutput7 = callbackObj.sOutValue7.split(',');
//     if(sOutput7[0] < 3) {
//       // console.log(55555555)
//       $('.part6-1').show()
//     }
//     // 14 新，15回
//     const sOutput5 = callbackObj.sOutValue5.split(',');
//     $('.tab5_newpeople').text(sOutput5[15])
//     $('.tab5_oldpeople').text(sOutput5[16])
//     const shareCode5 = sOutput5[0]
//     // 分享
//     var tab5PcUrl = 'https://cfhd.cf.qq.com/cp/a20220602mact/index.html?shareCode5=' + shareCode5
//     var tab5H5Url = 'https://cfhd.cf.qq.com/cp/a20220602mact/m.html?shareCode5=' + shareCode5
//     // 分享
//     var tab6PcUrl = 'https://cfhd.cf.qq.com/cp/a20220602mact/index.html?shareCode6=' + shareCode5
//     var tab6H5Url = 'https://cfhd.cf.qq.com/cp/a20220602mact/m.html?shareCode6=' + shareCode5
//     $('#tab5_copytext5').val(tab5PcUrl)
//     $('#tab6_copytext6').val(tab6PcUrl)
//     if (!onceCtrl5) {
//       onceCtrl5 = true
//       var shareObj5 = initShareFunc(tab5PcUrl, tab5H5Url, '好友邀请您组团游戏', '限时极品免费抽', '限时极品免费抽', 'https://game.gtimg.cn/images/cfhd/cp/a20220602mact/share5.jpg', { height: 200, width: 200, class: '.qrcode5' }, 'share')
//       $('.tab5_btn_share_pc').click(shareObj5.shareQQ)
//       $('.tab5_btn_share_h5').click(shareObj5.shareH5)
//       $('.tab5_btn_share_zone').click(shareObj5.shareZone)
//       $('.tab5_btn_share_copy').click(function () {
//         copyText(tab5PcUrl, function () { alert('复制成功！') })
//       })
//       var shareObj6 = initShareFunc(tab6PcUrl, tab6H5Url, '好友送您一份稀有道具', '点击领取生化币兑换限定道具', '点击领取生化币兑换限定道具', 'https://game.gtimg.cn/images/cfhd/cp/a20220602mact/share6.jpg', { height: 224, width: 224, class: '.qrcode6' }, 'dia53')
//       $('.tab6_btn_share_pc').click(shareObj6.shareQQ)
//       $('.tab6_btn_share_h5').click(shareObj6.shareH5)
//       $('.tab6_btn_share_zone').click(shareObj6.shareZone)
//       $('.tab6_btn_share_copy').click(function () {
//         copyText(tab6PcUrl, function () { alert('复制成功！') })
//       })
//     }
//     // 10队伍id，11是否队长，12个人等级，13团队等级，14人数, 15 是否已经推荐过了
//     // 17队伍id，18是否队长，19个人等级，20团队等级，21人数, 22 是否已经推荐过了
//     if (sOutput5[17] != '0') {
//       // 有队伍
//       $('.tab5_team').show()
//       $('.tab5_no_team').hide()
//       $('#tab5_team_id').val(sOutput5[17])
//       $('.tab5_copy_team_id').unbind('click')
//       $('.tab5_copy_team_id').click(function () {
//         copyText((sOutput5[17] as string), function () { alert('复制成功！') })
//       })
//       if (parseInt((sOutput5[18] as string)) !== 1 || parseInt((sOutput5[22] as string)) == 1) {
//         // console.log(44444)
//         // bu是队长, 或者 点过
//         $('.tab5_tuijian_team').hide()
//       }
//     } else {
//       // 没队伍
//       $('.tab5_no_team').show()
//       $('.tab5_team').hide()
//     }
//     // 23开始队伍猎豹
//     const teamList = sOutput5.slice(23)
//     console.log(teamList)
//     // var domstr = '<tr><th>团队ID</th><th>团队人数</th></tr>'
//     var domstr = ''
//     if (teamList[0] != '0' && teamList[0] != '') {
//       teamList.forEach(function (ele: string) {
//         const team = ele.split('|')
//         domstr += `<tr> <td>${team[0]}</td> <td>${team[1]}</td> </tr>`
//         // domstr += '<tr><th>' + team[0] + '</th><th>' + team[1] + '</th></tr>'
//       })
//     }
//     console.log('555', sOutput5[20])
//     $('.tab5_team_list').empty()
//     $('.tab5_team_list').append(domstr)
//     $('.tab5_people_level').text(sOutput5[19])
//     $('.tab5_team_level').text(sOutput5[20])
//     $('.tab5_team_count').text(sOutput5[21])
//   }
//   doAmsActionDonson = function (a, b, resolve, reject, params, pop, before, config) {
//     giftConfig(a, b, resolve, reject, params, pop, config)
//     var beforeRes = before()
//     if (beforeRes) doAmsAction(a, b)
//     else console.log('exec error')
//   }
//   handleNormalBtnClassAndAmsSbumit(allBtn, iActivityId, doAmsActionDonson, initFunction, initFlow)
//   function doInitFunction() {
//     setTimeout(function () {
//       OutPutDonson('init', initFunction)
//     }, 500)
//   }
//   return doInitFunction
// }
var mainFuncAct = mainfunc();
// var mainFuncAct2 = mainfunc2()
cfhdToLogin({
    type: isPage
}).then(function (res) {
    $('#login_qq_span').text(res);
    if (!(0, utils_1.isWX)() && isPage !== 'nq') {
        amsSubmit(477184, 865378);
    }
    setTimeout(function () {
        mainFuncAct();
    }, 1500);
    // tab2Init()
    // mainFuncAct2()
    (0, utils_1.giftRecord)(isPage, iActivityId, giftId, 865827, '.btn_gift_record_donson');
    doAmsAction(480119, 866955);
    if (popClassName != '') {
        TGDialogS(popClassName);
    }
    else if (!(0, utils_1.isWX)()) {
        // if (isPage === 'nq') {
        //   $('#pop-dia-iframe').attr('src', 'https://cfhd.cf.qq.com/cp/a20220628cfhd/neiqian.html')
        // } else if (isPage === 'H5') {
        //   $('#pop-dia-iframe').attr('src', 'https://cfhd.cf.qq.com/cp/a20220628cfhd/h5.html')
        // } else {
        //   $('#pop-dia-iframe').attr('src', 'https://cfhd.cf.qq.com/cp/a20220628cfhd/pc.html')
        // }
        // setTimeout(function () {
        //   TGDialogS('dia-iframe')
        // }, 5000)
    }
});
// 分享弹窗处理
var map = new Map([
    ['shareCode1', 'pop2'],
    ['shareCode2', 'friend-gift'],
    // ['shareCode3', 'tc6'],
    ['shareCode5', 'dia52'],
    ['shareCode6', 'dia6']
]);
var popClassName = handleInitPop(map);
TGDialogS(popClassName);
function handleInitPop(map) {
    var popClass = '';
    map.forEach(function (val, key) {
        if ((0, utils_1.getUrlParam)(key)) {
            popClass = val;
        }
    });
    return popClass || '';
}
function compareTimeNow(time) {
    var strArray = time.split(' ');
    var strDate = strArray[0].split('-');
    var strTime = strArray[1].split(':');
    var newTime = new Date(strDate[0], parseInt(strDate[1]) - 1, strDate[2], strTime[0], strTime[1], strTime[2]);
    var now = new Date();
    if (newTime.getTime() >= now.getTime()) {
        // 传入比现在大
        return true;
    }
    else {
        return false;
    }
}
var time = '2022-07-16 00:00:00';
if (!compareTimeNow(time)) {
    // show btn
    $('.tab1_get_yuyue_gift').removeClass('gray');
}
var itemList = [0, 0, 0, 0];
window.changeItemChoice = function (index, gift_type) {
    itemList[index] = gift_type;
};
function showXuyuanState(itemList) {
    itemList.forEach(function (ele, index) {
        // tab2_xuyuan_0_1
        $(".tab2_xuyuan_".concat(index, "_").concat(ele)).addClass('gray');
    });
}
function getXuyuanType() {
    if (itemList.indexOf(0) > -1 || itemList.length != 4) {
        alert('抱歉，请选好所有奖池~');
        return false;
    }
    else {
        var s = itemList.join(',');
        window.amsCfg_861892.sData.gift_list = s;
        return true;
    }
}
function getTab1ShareCode() {
    if ((0, utils_1.getUrlParam)('shareCode1')) {
        ;
        window.amsCfg_865867.sData.shareCode1 = (0, utils_1.getUrlParam)('shareCode1');
        return true;
    }
    else {
        alert('请确认您的邀请链接~');
        return false;
    }
}
function getTab2ShareCode() {
    if ((0, utils_1.getUrlParam)('shareCode2')) {
        ;
        window.amsCfg_862443.sData.shareCode2 = (0, utils_1.getUrlParam)('shareCode2');
        return true;
    }
    else {
        alert('请确认您的邀请链接~');
        return false;
    }
}
function getTab4ShareCode() {
    if ((0, utils_1.getUrlParam)('shareCode4')) {
        ;
        window.amsCfg_856635.sData.shareCode4 = (0, utils_1.getUrlParam)('shareCode4');
        return true;
    }
    else {
        alert('请确认您的邀请链接~');
        return false;
    }
}
function getTab5ShareCode() {
    if ((0, utils_1.getUrlParam)('shareCode5')) {
        ;
        window.amsCfg_864112.sData.shareCode5 = (0, utils_1.getUrlParam)('shareCode5');
        return true;
    }
    else {
        alert('请确认您的邀请链接~');
        return false;
    }
}
function getTab6ShareCode() {
    if ((0, utils_1.getUrlParam)('shareCode6')) {
        ;
        window.amsCfg_864366.sData.shareCode6 = (0, utils_1.getUrlParam)('shareCode6');
        return true;
    }
    else {
        alert('请确认您的邀请链接~');
        return false;
    }
}
function getTab2TeamId() {
    if ($('.tab2_team_id').val()) {
        ;
        window.amsCfg_866032.sData.teamid = $('.tab2_team_id').val();
        return true;
    }
    else {
        alert('请确认您的团队id~');
        closeDialog();
    }
}
function getTab4TeamId() {
    if ($('.tab4_team_id').val()) {
        ;
        window.amsCfg_866661.sData.area = window.areaid;
        window.amsCfg_866661.sData.teamid = $('.tab4_team_id').val();
        return true;
    }
    else {
        alert('请确认您的团队id~');
        closeDialog();
    }
}
function getTab5TeamId() {
    if ($('#tab5_join_team_id').val()) {
        ;
        window.amsCfg_863222.sData.teamid = $('#tab5_join_team_id').val();
        return true;
    }
    else {
        alert('请确认您的团队id~');
        closeDialog();
    }
}
$('.create_role').click(function () {
    if ($('#prename').val()) {
        var urlInfo = window.location.href.split('.html');
        var urlArr = urlInfo[0].split('/');
        var Channelid = channelIdArr[urlArr[5]] || '767';
        if (!Channelid) {
            alert('渠道错误');
            return;
        }
        console.log(Channelid);
        window.amsCfg_868627.sData.hkChannel = Channelid;
        window.amsCfg_868627.sData.preNickName = $('#prename').val();
        doAmsAction(479482, 868627);
    }
    else {
        alert('请您正确填写游戏昵称~');
    }
});
window.amsCfg_868627 = {
    iAMSActivityId: '479482',
    activityId: '490479',
    _everyRead: true,
    sData: {
        preNickName: '',
        hkChannel: '767'
    },
    onBeginGetGiftEvent: function () {
        return 0; // 抽奖前事件，返回0表示成功
    },
    onGetGiftFailureEvent: function (callbackObj) {
        // 抽奖失败事件
        alert(callbackObj.sMsg);
    },
    onGetGiftSuccessEvent: function (callbackObj) {
        // 抽奖成功事件
        // alert(callbackObj.sMsg)
        alert('恭喜你，创角成功！');
        window.location.reload();
    }
};
var channelIdArr = {
    index_hsj: 767,
    index: 767,
    m: 769,
    m_hsj: 769,
    wg: 767,
    hy: 12,
    djc: 19,
    gj: 15,
    llq: 77,
    xy: 21,
    txjsq: 16,
    yyx: 78,
    wegame: 14,
    hyh5: 12,
    djch5: 19,
    cfmwx: 79,
    cfmqq: 80,
    wx: 10,
    sq: 11,
    yyb: 17,
    wxxcx: 81,
    sqxcx: 82,
    hw: 70,
    vivo: 74,
    oppo: 73,
    haoyou4399: 71,
    yys: 83,
    beiyong: 766
};
window.areaname = '请选择区服';
window.areaid = '0';
window.cfSubmitDonson;
window.submitFlowId = 0;
// var cfSubmit: any;
// (window as any).cfSubmit = function(){};
var flowId2position = {
    849408: '0',
    849410: '1'
};
window.areaGetDonson = function (index, position) {
    if (index === void 0) { index = 0; }
    ;
    window.submitFlowId = index;
    TGDialogS('pop111');
    window.cfSubmitDonson = function () {
        ;
        window.areaname = $('.area-name2').html();
        window.areaid = $('.area-name2').attr('data');
        if (window.areaid != '0' && window.areaname != '请选择区服') {
            need('util.modalDialog', function (Dialog) {
                Dialog.alert('您的CF角色大区为【' + window.areaname + '】吗？', {
                    onConfirm: function () {
                        var flowIdPosition = position || flowId2position[window.submitFlowId] || '0';
                        window['func_479482_' + window.submitFlowId + '_' + flowIdPosition]();
                    },
                    onCancel: function () {
                        ;
                        window.areaGetDonson(index);
                    },
                    onClose: function () { }
                });
            });
        }
        else {
            ;
            window.areaGetDonson(index);
        }
    };
};
// interface rank {
//   Rank: string
//   Nickname: string
//   Total: string
//   Win: string
// }
// // type userInfo struct {
// //   Rank     int    `json:"rank"`
// //   Total    string `json:"total"`
// //   Win      string `json:"win"`
// //   Nickname string `json:"nickname"`
// // }
// declare let rank_data: Array<rank>;
if (window.rank_data) {
    // {"railId":"","worldid":"600","rank":"499","total":"28","win":"13","nickname":"","score":"8052"}
    //   <th>排名</th>
    //   <th>玩家昵称</th>
    //   <th>场数</th>
    //   <th>段位</th>
    //   <tr> <td>1</td> <td>玩家昵称</td> <td>玩家昵称</td> <td>玩家昵称</td> </tr>
    // const list = JSON.parse(rank_data)
    var resDom_1 = '';
    window.rank_data.forEach(function (ele) {
        resDom_1 += "<tr> <td>".concat(ele.rank, "</td> <td>").concat(ele.nickname, "</td> <td>").concat(ele.win, "</td> <td>").concat(ele.total, "</td> </tr>");
    });
    $('.rank_list').empty();
    $('.rank_list').append(resDom_1);
}
//提交请求至AME
;
window.amsCfg_865378 = {
    _everyRead: true,
    iActivityId: 477184,
    iFlowId: 865378,
    sNeedSubmitPopDiv: false,
    sData: {
    //自定义传参
    },
    fFlowSubmitEnd: function (res) {
        // alert('返回数据为:' + res);
        // 0.0.0   0
        var num = parseInt(res.sOutValue1);
        // num = 503200
        var level = Math.floor(num / 500000);
        if (level > 10)
            level = 10;
        $('.yuyue_count').text(num);
        $('.progress_donson').addClass("jdt".concat(level + 1));
        // console.log('yueyuecount', res)
        console.log(res);
        return;
    },
    fFlowSubmitFailed: function (res) {
        //失败会走到这个函数
        console.log(res);
    }
};
$('.tab3_create_kol').click(function () {
    doAmsAction(480119, 866952);
});
$('.tab3_daka_kol').click(function () {
    if ($('#tab3_daka_kol').val()) {
        ;
        window.amsCfg_866882.sData.kolcode = $('#tab3_daka_kol').val();
        doAmsAction(480119, 866882);
    }
    else {
        alert('请输入KOL兑换码~');
    }
});
$('.tab3_login_gift').click(function () {
    doAmsAction(480119, 866901);
});
$('.tab3_daka_gift').click(function () {
    doAmsAction(480119, 866903);
});
window.amsCfg_866882 = {
    iAMSActivityId: '480119',
    activityId: '490913',
    sData: {
        kolcode: ''
    },
    onBeginGetGiftEvent: function () {
        return 0; // 抽奖前事件，返回0表示成功
    },
    onGetGiftFailureEvent: function (callbackObj) {
        // 抽奖失败事件
        alert(callbackObj.sMsg);
    },
    onGetGiftSuccessEvent: function (callbackObj) {
        // 抽奖成功事件
        alert(callbackObj.sMsg);
    }
};
window.amsCfg_866901 = {
    iAMSActivityId: '480119',
    activityId: '490913',
    sData: {
        kolcode: ''
    },
    onBeginGetGiftEvent: function () {
        return 0; // 抽奖前事件，返回0表示成功
    },
    onGetGiftFailureEvent: function (callbackObj) {
        // 抽奖失败事件
        alert(callbackObj.sMsg);
    },
    onGetGiftSuccessEvent: function (callbackObj) {
        // 抽奖成功事件
        alert(callbackObj.sMsg);
    }
};
window.amsCfg_866903 = {
    iAMSActivityId: '480119',
    activityId: '490913',
    sData: {
        kolcode: ''
    },
    onBeginGetGiftEvent: function () {
        return 0; // 抽奖前事件，返回0表示成功
    },
    onGetGiftFailureEvent: function (callbackObj) {
        // 抽奖失败事件
        alert(callbackObj.sMsg);
    },
    onGetGiftSuccessEvent: function (callbackObj) {
        // 抽奖成功事件
        alert(callbackObj.sMsg);
    }
};
window.amsCfg_866952 = {
    _everyRead: true,
    iActivityId: 480119,
    iFlowId: 866952,
    sNeedSubmitPopDiv: false,
    sData: {
    //自定义传参
    },
    fFlowSubmitEnd: function (res) {
        // console.log('yueyuecount', res)
        doAmsAction(480119, 866955);
        alert('恭喜你，成功生成KOL码');
        // console.log(res.jData.sKOLcode)
        return;
    },
    fFlowSubmitFailed: function (res) {
        //失败会走到这个函数
        alert('抱歉，您不满足条件，生成失败~');
        console.log(res);
    }
};
var chaxunonce = false;
window.amsCfg_866955 = {
    _everyRead: true,
    iActivityId: 480119,
    iFlowId: 866955,
    sNeedSubmitPopDiv: false,
    sData: {
    //自定义传参
    },
    fFlowSubmitEnd: function (res) {
        // console.log('yueyuecount', res)
        // console.log(res.jData.sKOLcode)
        if (res.jData.sTVcode != 0) {
            var mydkcode = res.jData.sKOLcode;
            $('.tab3_kol_code').text(mydkcode);
            if (!chaxunonce) {
                chaxunonce = true;
                $('.copy_kol_code').click(function () {
                    (0, utils_1.copyText)(mydkcode, function () {
                        alert('复制成功');
                    });
                });
            }
        }
        return;
    },
    fFlowSubmitFailed: function (res) {
        //失败会走到这个函数
        console.log(res);
    }
};
$('.buy_2_yuan').click(function () {
    doAmsAction(479482, 868608);
});
window.amsCfg_868608 = {
    iActivityId: '479482',
    iFlowId: '868608',
    sData: {
        sArea: 600
    },
    fFlowSubmitEnd: function (res) {
        need(['ams.daoju_buy_svr.daoju_buy_svr'], function (DaojuBuy) {
            var option = {
                //apptype:4	新版webpay，已默认
                onPaySuccess: function () {
                    $('.buy_2_yuan').addClass('gray');
                } //支付成功后回调方法
                //onPayClose:function(){}//关闭支付页面回调方法
            };
            DaojuBuy.svrPay(res.jData, option);
        });
    },
    fFlowSubmitFailed: function (res) {
        alert(res.sMsg);
    }
};
milo.ready(function () {
    need(['ams.daoju_buy_svr.appid'], function (autoappid) {
        autoappid.init('cfhd', 25597, function (final_appid) {
            //final_appid为自动判断得到的道聚城渠道号
            //本段代码内自动进行道聚城全流程数据的收集，必须保留并放到milo.ready内，除非自行在页面上进行基于道聚城活动号的eas曝光上报
        });
    });
});
